import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileService, FilesResponse } from '../../../services/file.service';

@Component({
  selector: 'app-language-toggle',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="lt" role="group" aria-label="Language">
      <button type="button"
              class="lt__btn"
              [class.lt__btn--active]="current === 'en'"
              (click)="set('en')"
              [attr.aria-pressed]="current === 'en'">
        EN
      </button>
      <button type="button"
              class="lt__btn"
              [class.lt__btn--active]="current === 'hi'"
              [disabled]="!hasHindi"
              [attr.title]="hasHindi ? 'Switch to Hindi' : 'Hindi version not available for this post'"
              (click)="set('hi')"
              [attr.aria-pressed]="current === 'hi'">
        हिं
      </button>
    </div>
  `,
  styles: [`
    .lt {
      display: inline-flex;
      padding: 2px;
      border-radius: var(--radius-pill);
      background: var(--color-surface-alt);
      border: 1px solid var(--color-border);
    }
    .lt__btn {
      min-width: 38px;
      padding: var(--space-1) var(--space-3);
      border: 0;
      background: transparent;
      border-radius: var(--radius-pill);
      font-size: var(--fs-xs);
      font-weight: var(--fw-semibold);
      color: var(--color-text-secondary);
      cursor: pointer;
      transition: background var(--dur-fast) var(--ease-out), color var(--dur-fast) var(--ease-out);
      letter-spacing: 0.04em;
    }
    .lt__btn:hover:not([disabled]) { color: var(--color-text-primary); }
    .lt__btn--active {
      background: var(--color-surface);
      color: var(--color-primary-600);
      box-shadow: var(--shadow-xs);
    }
    .lt__btn[disabled] { opacity: 0.4; cursor: not-allowed; }
  `]
})
export class LanguageToggleComponent {
  @Input({ required: true }) bundle!: FilesResponse;
  @Input() current: 'en' | 'hi' = 'en';
  @Output() langChange = new EventEmitter<'en' | 'hi'>();

  private fileService = inject(FileService);

  get hasHindi(): boolean {
    return this.fileService.bundleHasHindi(this.bundle);
  }

  set(lang: 'en' | 'hi'): void {
    if (lang === this.current) return;
    if (lang === 'hi' && !this.hasHindi) return;
    this.langChange.emit(lang);
  }
}
